import React, { Component } from 'react';
import { Styles } from './styles/contact.js';

class GoogleMap extends Component {
    render() {
        const iframeSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.020256927675!2d90.44839833654072!3d23.817878700288908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c6263059ed0f%3A0xcba1205b7f185aa4!2sBlock%20L%2C%20Dhaka!5e0!3m2!1sen!2sbd!4v1756615017470!5m2!1sen!2sbd";

        return (
            <Styles>
                <div className="google-map-area" style={{ position: 'relative', width: '100%', height: '450px', marginTop: '20px', marginBottom: '20px', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
                    <iframe
                        src={iframeSrc}
                        width="100%"
                        height="100%"
                        style={{ border: 0, borderRadius: '8px', backgroundColor: 'rgba(0, 0, 0, 0.2)' }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Map for Cozy Couture"
                    ></iframe>
                </div>
            </Styles>
        );
    }
}

export default GoogleMap;